import PropTypes from 'prop-types';
import React from 'react';
import InstructionsView from 'components/tools/InstructionsView';

const Instructions = ({nextView}) => <InstructionsView
  onSubmit={nextView}
  title='tools.verify.instructions.title'
  remember={[
    'tools.verify.account.address',
    'tools.verify.indentify.addresses',
    'tools.verify.verification.manual',
    'tools.verify.list.show',
    'tools.verify.reattempt.verification',
  ]}
  instructions={[
    {
      title: 'tools.instructions.run.report',
      body: 'tools.verify.start.list',
    },
    {
      title: 'tools.instructions.review.report',
      body: 'tools.verify.review.list',
    },
    {
      title: 'tools.verify.confirm.verified',
      body: 'tools.verify.click.verify',
    },
  ]}
/>;

Instructions.propTypes = {
  nextView: PropTypes.func.isRequired,
};

export default Instructions;
